import request from "@/utils/request";

/**
 * 党建工作接口
 *
 */
export function api() {
  return {
    getList: () => {
      return request({
        url: "/website/serve/front/list",
        method: "get",
      });
    },
    getDetail: (id) => {
      return request({
        url: "/website/serve/front/detail",
        method: "get",
        params: {
          id,
        },
      });
    },
  };
}
